
import { Box, Button, Divider, InputBase, InputLabel, Paper, Typography , InputAdornment, IconButton,RadioGroup,Tooltip,FormControlLabel,Radio,Autocomplete,TextField } from "@mui/material"
import { updateEmail, updateMobile, updatePassword, updateFirstName, updateLastName, updateRole,updateId, updateProfile, updateMemberResponse, updateOtpCheck, updateUserName,updateWhatsapp,updateMembership,updateConrtol, updateFormType, updateSigninForm ,updateOtpVerifyPopup, updateMpinRequirements, updateMpinOptional} from "../redux/user_reducer"
import { updateSnackBarOpen,updateSnackBarSeverity,updateSnackBarMessage } from "../redux/snackbar"
import mayi_logo from "../assets/mayi_global_dark.png"
import {inputStyles} from "./signup_form"
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useMediaQuery } from "react-responsive"
import axios from "axios"
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate,useLocation } from "react-router-dom";
import { useState,useRef } from "react"
import CustomAxios from '../utils/CustomAxios';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import {jwtDecode} from 'jwt-decode';
import loginImage from "../assets/Mobile-Login.jpg"
import CircularProgress from '@mui/material/CircularProgress';
import { useEffect } from "react";
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
// import { GoogleLogin } from '@react-oauth/google'; // Import GoogleLogin component
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import MessageBar from "../modules/messageBar"
import { TranslateText } from "../utils/googletranslator"
import { updateOpen } from "../redux/congrats"
import OtpVerifyOption from "../components/otp_verify_option"
import { countries as countries_json } from "../countries";
import { getCountryPhoneLength } from "../utils/countryPhoneRules";
import {
  normalizePhoneDigits,
  validateLocalMobile,
  buildPhonePayload,
} from "../utils/phoneNumber";
import { MuiOtpInput } from "mui-one-time-password-input";
// import jwt from "jsonwebtoken"
const LoginForm = () => {
    const dispatch = useDispatch()
    const isMobile = useMediaQuery({ maxWidth: 600 });
const user_data = useSelector((state) => state.user);

    const [pendingCountry, setPendingCountry] = useState(null);

    const [countries, setCountries] = useState([]);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [selectedCountry, setSelectedCountry] = useState(null);
  const identityNumber = useSelector((state) => state.user.identityNumber);
const email = useSelector(state => state.user.email )
const userName=useSelector(state=>state.user.user_name)
const [response,setResponse]=useState("")
const [isloading, setIsloading] = useState(false)
const [errors,setErrors]=useState({})
const { executeRecaptcha } = useGoogleReCaptcha();
const navigate=useNavigate()
const [openMember, setOpenMember] = useState(false);
const [openNonMember, setOpenNonMember] = useState(false);
const member=useSelector((state)=>state.user.member)
const tooltipRef = useRef(null);
const clientId = "521447616048-relr5c80sac2rudgmfub8kantovfc5pe.apps.googleusercontent.com"; // Replace with your actual client ID
const [platform,setPlatform]=useState("web")
const accessControl=useSelector(state=>state.user.accessControl)
const location=useLocation()
let [pages,setPages]=useState([])
    let [module,setModule]=useState([])
const [showOtpVerification, setShowOtpVerification] = useState(false)
const [mpinLoginVisible, setMpinLoginVisible] = useState(false)
const [mpinValue, setMpinValue] = useState("")
const [mpinMessage, setMpinMessage] = useState("")
const [mpinLockout, setMpinLockout] = useState({ attempts_left: 3, lock_remaining_seconds: 0 })
const attemptsLeft = Number.isFinite(Number(mpinLockout?.attempts_left))
    ? Number(mpinLockout.attempts_left)
    : 0
const showAttempts = mpinLoginVisible && attemptsLeft >= 0 && attemptsLeft < 3
const verifyCaptcha = ()=>{
    if (!executeRecaptcha) {
        return;
    }
  
    executeRecaptcha('login_page').then((token)=>{
        handleSummit(token)
        // console.log("////////////////token////////////",token)
    })
    // return token
}

useEffect(()=>{
setErrors({})
setResponse("")
},[member])

const memberTooltip = () => {
    setOpenMember(true);
  };
  const memberTooltipClose = () => {
    setOpenMember(false);
  };
  const nonMemberTooltip = () => {
    setOpenNonMember(true);
  };
  const nonMemberTooltipClose = () => {
    setOpenNonMember(false);
  };
const handleSummit = async () => {
    const formData = {
        email_or_username: user_data.mobile_no,
    };
    const isValid = validateForm(formData);
    if (!isValid) {
        return;
    }

    const phoneResult = buildPhonePayload({
        mobile: user_data.mobile_no,
        dialcode: selectedCountry?.dialCode || "+91",
        countryCode: selectedCountry?.value,
        maxLength: selectedCountry?.numberLength || 15,
    });
    if (!phoneResult.ok) {
        setErrors((prev) => ({ ...prev, email_or_username: phoneResult.error }));
        return;
    }

    const { mobileno, dialcode } = phoneResult.payload;
    setIsloading(true);
    setResponse("");
    try {
        const { data: intent } = await CustomAxios.post("login-intent/", {
            mobile_no: mobileno,
            dial_code: dialcode,
        });

        dispatch(updateMpinRequirements(intent.requirements || {
            mpin_setup_required: false,
            mpin_change_required: false,
            mpin_force_reset_required: false,
        }));
        dispatch(updateMpinOptional(false));

        if (intent.next_step === "mpin_login") {
            // show MPIN login screen instead of OTP
            setShowOtpVerification(false);
            setIsloading(false);
            setResponse("");
            // store mobile for MPIN login
            dispatch(updateMobile(mobileno));
            // MPIN entry handled via separate UI (not OTP modal)
            setMpinLoginVisible(true);
            setMpinLockout(intent.lockout || { attempts_left: 3, lock_remaining_seconds: 0 });
            setMpinMessage(intent.message_body || "Enter your 6-digit MPIN to login.");
            return;
        }

        // Intent says OTP login: go to existing OTP flow (delivery card + OTP screen)
        setMpinLoginVisible(false);
        setShowOtpVerification(false);
        
        await requestLoginOtp(mobileno, dialcode);
    } catch (error) {
        setResponse(error.response?.data?.message || "Failed to start login. Please try again.");
        setIsloading(false);
    }
};
const authtoken=localStorage.getItem("authtoken")
useEffect(()=>{
    dispatch(updateOtpVerifyPopup(false))
    if (authtoken){
        const decode=jwtDecode(authtoken)
        if (decode.role=='admin'){
       
    const access=accessControl.filter(item=>item.role==decode.control)[0]
    // console.log("????????????????????access",authToken)
    // decode.control
    // console.log(access.access)
    let module=[]
    let pages=[]
    access?.access?.map(item=>{
        // console.log(item,typeof(item))
        if(typeof(item)=='object' ){
           module.push(Object.keys(item)[0])
           pages=[...pages,...Object.values(item)[0]]
        }
        else if(typeof(item)=='string' ){
            pages.push(item)

        }
    })
    // console.log("??????????????? params",location,id)
    setPages(pages)
    setModule(module)
    navigate(pages[0])
}
else{
    if (localStorage.getItem("redirect")){
        navigate(localStorage.getItem("redirect"))
    }
    else{
        navigate("/")
    }
}
      
    }

},[])
const handleCountryChange = (event, value) => {
    const selectedOption = countries.find(
      (country) => country.value === value?.value
    );
    const hasDetails = user_data.mobile_no || identityNumber;
    // console.log(selectedOption?.value,selectedCountry?.value)

    if (selectedCountry?.value !== selectedOption?.value) {
        // console.log("?????inside first condition",hasDetails)
      if (hasDetails) {
        // console.log(selectedOption)
        setSelectedCountry(selectedOption || null);
        // setIsDialogOpen(true);
      } else {
        // console.log(selectedOption)
        setSelectedCountry(selectedOption || null);
      }
    }
  };
  const fetchCountries = async () => {
    const access_key = "3c20bc99871906ff01975e743bec3a5b";
    try {
      // const response = await axios.get("https://restcountries.com/v3.1/all/");
      const response = {"data":countries_json}
      // console.log(response);
      return response.data.map((country) => ({
        value: country.cca2,
        label: country.name.common,
        dialCode: country.idd?.root + (country.idd?.suffixes?.[0] || ""),
        flag: country.flags?.png,
        numberLength: getCountryPhoneLength(country.cca2),
      }));
    } catch (error) {
      // console.error("Error fetching countries:", error);
      return [];
    }
  };

  useEffect(() => {
    const getCountries = async () => {
      const countryOptions = await fetchCountries();
      setCountries(countryOptions);

      // Set India as the default option
      const india = countryOptions.find((country) => country.value === "IN") || countryOptions[0] || null;
      setSelectedCountry(india);
    //   setMobileNo(india ? "" : "");
    };

    getCountries();
  }, []);
const requestLoginOtp=async(normalizedMobile, dialcode)=>{
    setIsloading(true)
    setResponse("")
    const payload = {
        email_or_username: normalizedMobile,
        member: member,
        password: null,
        cart: JSON.parse(localStorage.getItem('cart') || '[]'),
    };
    if (dialcode) {
        payload.dialcode = dialcode;
    }
    await CustomAxios.post(`login/`, payload).then(({data})=>{
        setIsloading(false)
        if(data.message=='OTP has been sent' || data.message=='Successfully identified user'){
            // console.log(data.data.id)
            dispatch(updateOtpCheck("login"))
            dispatch(updateEmail(data.data?.email || data.email))
            dispatch(updateMobile(data.data?.mobileno || data.mobileno))
            dispatch(updateId(data.data?.id || data.id))
            dispatch(updateWhatsapp(data.data?.whatsapp || data.whatsapp))
            setShowOtpVerification(true)
        }
        else if(data.message=='Successfully identified user' && data.access_token){
            // Direct login if token provided
            handleLoginSuccess(data)
        }
        else{
            setResponse(data.message || "An error occurred")
        }           
    }).catch(error=>{
        setIsloading(false)
        setResponse(error.response?.data?.message || "Failed to send OTP. Please try again.")
    })
}

const handleLoginSuccess = (data) => {
    dispatch(updateUserName(""))
    const decode=jwtDecode(data.access_token)
    localStorage.setItem("address",JSON.stringify(data.add || []))
    localStorage.setItem('authtoken', data.access_token);
    localStorage.setItem('refreshToken', data.refresh_token);
    dispatch(updateMemberResponse(data))
    dispatch(updateFirstName(decode.first_name))
    dispatch(updateLastName(decode.last_name))
    dispatch(updateEmail(decode.email))
    dispatch(updateRole(decode.role))
    dispatch(updateConrtol(decode.control))
    dispatch(updateId(decode.id))
    if (data.user && data.user.mobileno) {
        dispatch(updateMobile(data.user.mobileno))
    }
    if (data.att && Array.isArray(data.att) && data.att.length>0){
        dispatch(updateProfile(data.att[0].original))
    }
    dispatch(updateEmail(decode.email))

    if (decode.role=='admin'){
        const access=accessControl.filter(item=>item.role==decode.control)[0]
        let module=[]
        let pages=[]
        access.access.map(item=>{
            // console.log(item,typeof(item))
            if(typeof(item)=='object' ){
               module.push(Object.keys(item)[0])
               pages=[...pages,...Object.values(item)[0]]
            }
            else if(typeof(item)=='string' ){
                pages.push(item)
            }
        })
        setPages(pages)
        setModule(module)
        navigate(pages[0])
    }
    else{
        // if (localStorage.getItem("redirect") && location.pathname==='/login'){
        //     navigate(localStorage.getItem("redirect"))
        // }
        // else 
        if(location.pathname==='/login'){
            navigate("/dashboard")
        }
        else{
            dispatch(updateSigninForm(false))
        }
    }
}
const validateForm = (formData) => {
    let valid = true;
    const newErrors = {};
    if (!selectedCountry){
        newErrors.email_or_username = 'Please select Country code';
        valid = false;
    } else {
        const mobileError = validateLocalMobile({
            mobile: formData.email_or_username,
            countryCode: selectedCountry?.value,
            maxLength: selectedCountry?.numberLength || 15,
        });
        if (mobileError) {
            newErrors.email_or_username = mobileError;
            valid = false;
        }
    }

    setErrors(newErrors);
    return valid;
};
  const homePage=()=>{
    navigate("/products")
}

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSummit(); 
    }
  };
  useEffect(()=>{
    dispatch(updateEmail(""))
    dispatch(updatePassword(""))
  },[])
  useEffect(() => {
    // setReferralCode(queryParameters.get('code'));
    // if (queryParameters.get('code')){
    //   setPlatform('referred')
    // }
    // else if(queryParameters.get('signup_via')){
    //   localStorage.setItem('signup_via',queryParameters.get('signup_via'))
    //   navigate('/products')
      
    //   // setPlatform(queryParameters.get('signup_via'))
    // }
    if(localStorage.getItem('signup_via')){
      // console.log(localStorage.getItem('signup_via'))
      setPlatform(localStorage.getItem('signup_via'))
    }
    
  }, []);
//   const isMobile = useMediaQuery({ maxWidth: 600 });
    const isLaptop = useMediaQuery({ query: '(min-width: 900px)' });

    const handleGoogleSuccess = async (credentialResponse) => {
        const details = jwtDecode(credentialResponse.credential);
        // console.log(details);
        const { given_name, family_name, email } = details;
        // console.log(given_name, family_name, email);
    
        const payload = {
            email: email,
            first_name: given_name,
            last_name:  "family_name" in details?family_name:"",
            referralcode: "",
            is_active: true,
            registration_type: "google",
            platform:platform,
            cart:localStorage.getItem("cart")
        };
    
        // console.log(given_name);
        // console.log(family_name);
        // console.log(email);
    
        setIsloading(true);
        try {
            const response = await CustomAxios.post(`signup/`, payload);
            setIsloading(false);
    
            if (response.data.message === "Registration Successful!") {
                const decode = jwtDecode(response.data.access_token);
                localStorage.setItem("address", JSON.stringify(response.data.add));
                localStorage.setItem('authtoken', response.data.access_token);
                localStorage.setItem('refreshToken', response.data.refresh_token);
                // console.log(response.data.add);
                // console.log(decode);
                dispatch(updateMemberResponse(response.data));
                dispatch(updateFirstName(decode.first_name));
                dispatch(updateLastName(decode.last_name));
                dispatch(updateEmail(decode.email));
                dispatch(updateRole(decode.role));
                dispatch(updateConrtol(decode.control))
                dispatch(updateId(decode.id));
                if (response.data.att.length > 0) {
                    dispatch(updateProfile(response.data.att[0].original));
                }
                dispatch(updateEmail(decode.email));
                if (localStorage.getItem("redirect"  ) && location.pathname==='/login'){
                    navigate(localStorage.getItem("redirect"))
                }
                else if(location.pathname==='/login'){
                    navigate("/")
                }
                else{
                    // dispatch(updateOpen(true))
                    dispatch(updateSigninForm(false))
                }
            } else {
                setErrors({ passworderror: response.data.message });
                // console.log(response.data)
                // setErrors({googleSignin:response.data.error})
                if(response.data.error){
                    dispatch(updateSnackBarMessage(response.data.error))
                    dispatch(updateSnackBarSeverity("error"))
                  
                  dispatch(updateSnackBarOpen(true))
                }   
            }
        } catch (error) {
            setIsloading(false);
            // console.error(error);
        }
    };
    



    // const handleGoogleSuccess = async (credentialResponse) => {
    //     const details = jwtDecode(credentialResponse.credential);
    //     // console.log(details);
    //     const { given_name, family_name, email } = details;
    //     // console.log(given_name, family_name, email);
    
        
    //         const payload = {
    //             email: email,
    //             first_name: given_name,
    //             last_name: family_name,
    //             // password: '', 
    //             referralcode: "",
    //             is_active: true,
    //             registration_type: "google"
    //         };
    
    //         // console.log(given_name);
    //         // console.log(family_name);
    //         // console.log(email);
    
    //         setIsloading(true);
    //         try {
    //             const response = await CustomAxios.post(`signup/`, payload);
    //             setIsloading(false);
    //             if (response.data.message === "Registration Successful!") {
    //                 // console.log("hii")
    //                 navigate("/");
    //             } else {
    //                 setErrors({ passworderror: response.data.message });
    //             }
    //         } catch (error) {
    //             setIsloading(false);
    //             console.error(error);
    //         }
                
    // };

    return (
        <GoogleOAuthProvider clientId={clientId}>
            <MessageBar/>
        <Box component={isMobile ? "div" : Paper} sx={{ left: "50%", top: "50%", position:(location.pathname!=='/checkout'||isLaptop)&& "absolute", transform:(location.pathname!=='/checkout'||isLaptop)&&'translate(-50%, -50%)',display:"flex",alignItems:{xs:"center",sm:"initial"},justifyContent:{xs:"center",sm:"initial"},flexDirection: {sm:"row", xs:"column"},width: { md: "440px", xs: "100%",sm:"440px" }, maxWidth:{xs:"100%" ,md:"600px",sm:"600px"},height:{xs:"100%",sm:"auto",md:"auto"},minHeight:{xs:location.pathname!=="/checkout"?"100vh":"auto",md:"auto",sm:"auto"},backgroundImage:{xs:location.pathname!=="/checkout"?`url(${loginImage})`:"none",sm:"none"},backgroundSize:{xs:"cover",sm:"initial"},backgroundPosition:{xs:"center",sm:"initial"},backgroundRepeat:"no-repeat"}} >
        {location.pathname!=="/checkout"&&<Box src={loginImage} sx={{display:{md:"none",sm:"none",xs:"none"},width: {md:"50%", xs:"100%",sm:"50%"},height:{xs:"128px",sm:"100vh",md:"80vh"}, overflowY:"scroll",backgroundSize:"auto",objectFit:"cover",minHeight:{xs:"128px"}}} component="img" />}
        {location.pathname!=="/checkout" && isMobile && (
            <Box sx={{position:"absolute",top:"24px",left:"50%",transform:"translateX(-50%)",display:"flex",justifyContent:"center",width:"100%"}}>
                <Box src={mayi_logo} component='img' sx={{...inputStyles.logo,width:"220px"}} onClick={homePage}/>
            </Box>
        )}
            
            <Box sx={{width:"100%",padding:"32px",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:{xs:"center",sm:"initial"},backgroundColor:"transparent",position:"relative",top:{xs:"-80px",sm:"0"}}}>

           
            {location.pathname!=="/checkout" && !isMobile && <Box src={mayi_logo} component='img' sx={{...inputStyles.logo,width:{sm:"140px",md:"160px"}}} onClick={homePage}/>}
                <TranslateText sx={inputStyles.subHeading} color="grey.900"> Welcome back!</TranslateText>
                <TranslateText sx={inputStyles.constent} color="grey.900"> Sign in to access your account and explore.</TranslateText>
            <Box sx={{ display: "flex", flexDirection: "column", gap: "16px",width:"100%" }}>
            {/* <Box sx={{alignSelf:"start"}}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                            value={member}
                            onChange={(e)=>dispatch(updateMembership(e.target.value))}
                            >
                                 <Tooltip PopperProps={{  sx: {"& .MuiTooltip-tooltip": { backgroundColor: "#001F38",  color: "#fff",  }, "& .MuiTooltip-arrow": { color: "#001F38",   }, },   }} title={  <Box ref={tooltipRef}  sx={{ backgroundColor: "#001F38", color: "white",  fontSize: "12px", textAlign: "center", padding: "8px", borderRadius: "4px", boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)", maxWidth: "240px",}} ><TranslateText sx={{ fontSize: "12px",     color: "white",     textAlign: "left",    }} >MAYI IQ Member:</TranslateText>  <TranslateText sx={{ fontSize: "12px",     color: "white",     textAlign: "left",    }} > Unlock earning opportunities and special offers. Need to complete KYC verification.    </TranslateText>   </Box>}arrow open={openMember} onOpen={memberTooltip} onClose={memberTooltipClose}  placement="bottom" >
                            <FormControlLabel sx={{height:"20px",}} value="member" control={<Radio />} label={<TranslateText>Member</TranslateText>} />
                            </Tooltip>
                            <Tooltip PopperProps={{  sx: {"& .MuiTooltip-tooltip": { backgroundColor: "#001F38",  color: "#fff",  }, "& .MuiTooltip-arrow": { color: "#001F38",   }, },   }} title={  <Box ref={tooltipRef}  sx={{ backgroundColor: "#001F38", color: "white",  fontSize: "12px", textAlign: "center", padding: "8px", borderRadius: "4px", boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)", maxWidth: "240px",}} ><TranslateText sx={{ fontSize: "12px",     color: "white",     textAlign: "left",    }} >MAYI IQ Basic user:</TranslateText>  <TranslateText sx={{ fontSize: "12px",     color: "white",     textAlign: "left",    }} >This option is for casual users who want to explore the platform. No KYC is required.    </TranslateText>   </Box>}arrow open={openNonMember} onOpen={nonMemberTooltip} onClose={nonMemberTooltipClose}  placement="bottom" >
                            <FormControlLabel sx={{height:"20px",}} value="non_member" control={<Radio />} label={<TranslateText>Non Member</TranslateText> } />
                            </Tooltip>
                            
                            </RadioGroup>  
                        </Box> */}
                
                {!showOtpVerification && !mpinLoginVisible && (
                    <>
                        <Box sx={{display:"flex",gap:"5px"}}>
                                        <Box
                            // sx={{
                            //   display: "flex",
                            //   gap: "16px",
                            //   flexDirection: { xs: "column", sm: "row" },
                            // }}
                            >
                            <TranslateText sx={inputStyles.label} color="grey.700">
                                Country <span style={{ color: "red" }}>*</span>
                            </TranslateText>
                            <Autocomplete
                                sx={{ padding: "0px" ,height:"48px"}}
                                style={{ width: "140px" ,height:"48px"}}
                                options={countries}
                                getOptionLabel={(option) => option.value}
                                filterOptions={(options, { inputValue }) => {
                                    return options.filter(
                                      (item) =>
                                        item.dialCode?.toLowerCase().includes(inputValue?.toLowerCase()) ||
                                        item.label?.toLowerCase().includes(inputValue?.toLowerCase()) ||
                                        item.code?.toLowerCase().includes(inputValue?.toLowerCase())
                                    );
                                  }}
                                onChange={handleCountryChange}
                                value={selectedCountry || null}
                                isOptionEqualToValue={(option, value) =>
                                value ? option?.value === value?.value : false
                                } // Check for null value
                                renderOption={(props, option) => {
                                const { key, ...optionProps } = props;
                                return (
                                <Box
                                    key={key}
                                    {...optionProps}
                                    sx={{ display: "flex", alignItems: "center" }}
                                >
                                    <img
                                    src={option.flag}
                                    alt={option.label}
                                    style={{
                                        width: "20px",
                                        marginRight:"15px"
                                        // height: "15px",
                                        // marginRight: "15px",
                                    }}
                                    />
                                    {option.dialCode}
                                </Box>
                                );
                                }}
                                renderInput={(params) => (
                                <TextField
                                    sx={{ height: "48px" }}
                                    {...params}
                                    placeholder="Search country..."
                                    variant="outlined"
                                    InputProps={{
                                    ...params.InputProps,
                                    startAdornment: selectedCountry?.flag && (
                                        <img
                                        src={selectedCountry.flag}
                                        alt={selectedCountry.label}
                                        style={{
                                            width: "20px",
                                            height: "15px",
                                            // marginRight: "10px",
                                            // marginLeft: "5px",
                                        }}
                                        />
                                    ),
                                    }}
                                />
                                )}
                                // style={{ width: "100%" }}
                            />
                            
                            </Box>
                            
                            <Box>
                                <TranslateText sx={inputStyles.label}>
                                    Mobile Number <span style={{ color: "red" }}>*</span>
                                </TranslateText>
                                <InputBase autoComplete="tel-national" value={user_data.mobile_no}  onChange={(e) =>{ const maxLength = selectedCountry?.numberLength || 15; const cleanedValue = normalizePhoneDigits(e.target.value).slice(0, maxLength); dispatch(updateMobile(cleanedValue)); }} sx={inputStyles.inputBase} startAdornment={selectedCountry&&<Typography sx={{marginRight:"15px"}}>{selectedCountry.dialCode}</Typography>}  inputProps={{ maxLength: selectedCountry?.numberLength || 15, inputMode: "numeric", pattern: "[0-9]*" }} placeholder="Enter your mobile number" />   
                            </Box>

                            </Box> 
                            {errors?.email_or_username && (
                            <TranslateText
                                sx={{
                                mt: "4px",
                                fontWeight: 400,
                                fontSize: "14px",
                                color: "error.light",
                                alignSelf: "flex-start",
                                // background: "red",
                                }}
                            >
                                {errors?.email_or_username}
                            </TranslateText>
                            )}
                        
                        <TranslateText sx={{color:"error.light"}}>{response}</TranslateText>
                        
                        <Button variant="contained" sx={inputStyles.button} onClick={handleSummit}>
                            {isloading ? <CircularProgress color="inherit" size={30}/> : <TranslateText>Send OTP</TranslateText>}
                        </Button>
                    </>
                )}
                {mpinLoginVisible && (
                    <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: 2 }}>
                        {(mpinMessage || response) && (
                            <TranslateText sx={{ fontSize: 14, color: (mpinMessage && (mpinMessage.includes("Incorrect") || mpinMessage.includes("locked") || mpinMessage.includes("attempts"))) || response ? "error.main" : "text.secondary" }}>
                                {response || mpinMessage}
                            </TranslateText>
                        )}
                        <MuiOtpInput
                            value={mpinValue}
                            onChange={(value) => setMpinValue(value.replace(/[^0-9]/g, "").slice(0, 6))}
                            length={6}
                            gap={1}
                            autoFocus
                            sx={{ marginTop: "8px" }}
                        />
                        {showAttempts && (
                            <TranslateText
                                sx={{
                                    mt: "4px",
                                    fontWeight: 400,
                                    fontSize: "14px",
                                    color: "error.light",
                                    alignSelf: "flex-start",
                                }}
                            >
                                {`Attempts left: ${attemptsLeft} of 3`}
                            </TranslateText>
                        )}
                        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                            <Button
                                variant="contained"
                                sx={inputStyles.button}
                                onClick={async () => {
                                    setIsloading(true);
                                    setResponse("");
                                    try {
                                        const normalizedMobile = normalizePhoneDigits(user_data.mobile_no);
                                        const { data } = await CustomAxios.post("mpin-login/", {
                                            mobile_no: normalizedMobile,
                                            dial_code: selectedCountry?.dialCode || "+91",
                                            mpin: mpinValue,
                                        });
                                        // success – same as OTP login success
                                        handleLoginSuccess(data);
                                    } catch (error) {
                                        const res = error.response?.data;
                                        if (res?.reason_code === "MPIN_LOCKED" && res.lockout) {
                                            setMpinLockout(res.lockout);
                                            dispatch(updateMpinRequirements(res.requirements || {
                                                mpin_setup_required: false,
                                                mpin_change_required: false,
                                                mpin_force_reset_required: true,
                                            }));
                                            setMpinLoginVisible(false);
                                            // fall back to OTP
                                            const normalizedMobile = normalizePhoneDigits(user_data.mobile_no);
                                            await requestLoginOtp(normalizedMobile, selectedCountry?.dialCode);
                                        } else if (res?.reason_code === "MPIN_INVALID" && res.lockout) {
                                            setMpinLockout(res.lockout);
                                            setResponse(res.detail || "Incorrect MPIN.");
                                        } else if (res?.reason_code === "MPIN_OTP_REQUIRED") {
                                            dispatch(updateMpinRequirements(res.requirements || {
                                                mpin_setup_required: true,
                                                mpin_change_required: false,
                                                mpin_force_reset_required: false,
                                            }));
                                            setMpinLoginVisible(false);
                                            const normalizedMobile = normalizePhoneDigits(user_data.mobile_no);
                                            await requestLoginOtp(normalizedMobile, selectedCountry?.dialCode);
                                        } else {
                                            setResponse(res?.detail || "Failed to login with MPIN.");
                                        }
                                    } finally {
                                        setIsloading(false);
                                    }
                                }}
                            >
                                {isloading ? (
                                    <CircularProgress color="inherit" size={30} />
                                ) : (
                                    <TranslateText>Login</TranslateText>
                                )}
                            </Button>
                            <Button
                                variant="text"
                                sx={{ textTransform: "none" }}
                                onClick={() => {
                                    // Forgot MPIN → force OTP + MPIN reset after, via normal OTP path
                                    dispatch(
                                        updateMpinRequirements({
                                            mpin_setup_required: false,
                                            mpin_change_required: false,
                                            mpin_force_reset_required: true,
                                        })
                                    );
                                    dispatch(updateMpinOptional(false));
                                    setMpinLoginVisible(false);
                                    const normalizedMobile = normalizePhoneDigits(user_data.mobile_no);
                                    requestLoginOtp(normalizedMobile, selectedCountry?.dialCode);
                                }}
                            >
                                <TranslateText>Forgot MPIN? Login with OTP</TranslateText>
                            </Button>
                        </Box>
                    </Box>
                )}
                {showOtpVerification && !mpinLoginVisible && (
                    <Box sx={{width:"100%"}}>
                        <OtpVerifyOption switchOTP={false} loginDialCode={selectedCountry?.dialCode} />
                    </Box>
                )}             
                <Box sx={{display:'flex',justifyContent:"center"}}>
                <TranslateText sx={{textAlign:"center",fontSize:"14px"}} > Don't have any account?&nbsp;</TranslateText><Link onClick={()=>location.pathname!=='/login'&&dispatch(updateFormType('signup') )} to={location.pathname=='/login' ? "/signup" : "#"} style={{textDecoration:"none",fontSize:"14px"}}><TranslateText sx={{textDecoration:"none",textDecorationLine:"underline",fontSize:"14px"}} color="primary">Sign up</TranslateText></Link>

                </Box>
                
                {/* <Divider sx={{fontSize:"14px"}} ><TranslateText>Or</TranslateText></Divider>
                <Box sx={{ display: "flex", justifyContent: "center", flexDirection:"column",alignItems:"center" }}>
                                <GoogleLogin
                                    onSuccess={handleGoogleSuccess}
                                    // onError={handleGoogleError}
                                />
                            </Box> */}
                        
                
              
                {/* <Box sx={{ display: "flex", justifyContent: "center", marginTop: "10px" }}>
                            <GoogleLogin
                                onSuccess={handleGoogleSuccess}
                                // onError={handleGoogleError}
                            />
                        </Box> */}
                {/* </Box> */}
            </Box>
            </Box>
        </Box>
        </GoogleOAuthProvider>
    )


}

export default LoginForm
